import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { flowResult } from 'mobx';
import { ForeclosureStageList } from './foreclosureStagesList';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { StandardDialog } from '@roc/ui';
import { Document as DocumentType } from '@roc/feature-types';
import { useForeclosureRequestStore } from '../../hooks/useForeclosureRequestStore';
import { useForeclosureSummaryStore } from '../../hooks/useForeclosureSummaryStore';
import { LoanDqStageData } from '../../types/loanDqStageData';

export type ForeclosureStageListItemProps = {
  open: boolean;
  onClose: () => void;
  loanId: string;
  document?: DocumentType;
};

export const ForeclosureStageListItem = observer(
  ({
    open,
    onClose,
    loanId,
    document,
  }: ForeclosureStageListItemProps) => {
    const { foreclosureRequestStore } = useForeclosureRequestStore();

    useEffect(() => {
      if(foreclosureRequestStore){
          foreclosureRequestStore.getActiveForeclosureDataByLoanId(loanId)
      }
    }, [open, loanId, foreclosureRequestStore]);

      const saveForeclosureStages = async (stages: LoanDqStageData) => {
        foreclosureRequestStore.saveForeclosureStages(loanId, stages);
        foreclosureRequestStore.getActiveForeclosureDataByLoanId(loanId);
      }


    const dialogContent = (
      <ForeclosureStageList
        loanId={loanId}
        store={foreclosureRequestStore}
        handleClose={onClose}
        handleSave={saveForeclosureStages}
      />
    );

    return (
      <>
        {document?.taskId ? (
          <CustomTaskDialog
            open={open}
            title="Foreclosure Stages"
            handleClose={onClose}
            dialogContent={dialogContent}
            taskId={document.taskId}
          />
        ) : (
          <StandardDialog
            open={open}
            title="Foreclosure Stages"
            maxWidth="lg"
            handleClose={onClose}
            dialogContent={dialogContent}
          />
        )}
      </>
    );
  }
);

export default ForeclosureStageListItem;
